import React from 'react'

import PropertyDesc from '../components/PropertyDesc'

const PropertyDescPage = () => {
  return (
    <div>
      <PropertyDesc />
    </div>
  )
}

export default PropertyDescPage